import { formatHtml } from "@trumpf/ux.common-storybook";
import { PageSliderTemplate } from "./page-slider.templates";

export default {
    title: "Website/Page Templates/Search/Search Results Sliders/Page Slider",
    render: PageSliderTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const PageSlider = {};
